import AboutCard from "../components/card";

const About = () => {
  return (
    <div className="about-wrp">
      <div class="container">
        <AboutCard
          h1={"Work Experience 1"}
          h2={"01"}
          h3={"Startup georgia - Full stack web developer"}
          p={"November 2023 - Present"}
          p2={
            "I have recently joined as a freelance full-stack developer, tasked with the revitalization of a website last updated in 2015. My role involves: "
          }
          points={[
            "Undertake a comprehensive update of the website's codebase and design to align with contemporary standards.",
            "Implement modern web development methodologies to enhance overall user experience.",
            "Engineer a robust and user-friendly administrative panel to facilitate seamless website management.",
            "dentify, analyze, and rectify any bugs or errors within the web application.",
            "Implement modern and responsive design strategies for optimal performance across diverse devices and screen sizes.",
          ]}
        />
        <AboutCard
          h1={"Work Experience 2"}
          h2={"02"}
          h3={"Digital Institute-Teaching Assistant"}
          p={"August 2023 - Present"}
          p2={
            "I commenced my studies at Digital Institute and, based on a recommendation from a lecturer, assumed the role of a Teaching Assistant for a different group five months later. "
          }
          points={[
            "Assisted students by reviewing and providing constructive feedback on their homework assignments.",
            "Conducted one-on-one meetings with students to clarify course material and offer assistance with coding.",
            "Monitored and tracked student completion of Excel homework assignments.",
          ]}
        />

        <AboutCard
          h1={"Languages"}
          h2={"03"}
          h3={" Languages "}
          points={[
            "English (Native)",
            "Georgian(Native)",
            "Turkish(B2)",
            "Russian(B2)",
            "Spanish(A1) ps. still in progress",
          ]}
          p={"Note: All languages are self tought"}
        />

        <AboutCard
          h1={"Education"}
          h2={"04"}
          h3={"University of Georgia 2019-2022"}
          p={"Bachelor's degree in Computer Science"}
        />

        <AboutCard
          h1={"Courses"}
          h2={"05"}
          h3={"Digital Institute"}
          p={
            "Course  includes: HTML| JavaScript|  Tailwind| Sass| Material UI| CSS| React.js| TypeScript|Angular| API Integrations | Bootstrap | Redux| Styled Components | Social Media Sign In-s "
          }
          p2={
            "I do believe in self Education so other than that I tought myself  Node.js| Next.js|Angular |MongoDB and more"
          }
          diploma={true}
        />
        <AboutCard
          h1={"Personal Skills"}
          h2={"06"}
          h3={" Personal Skills "}
          points={[
            "Proficient in both written and verbal communication, with the ability to convey complex ideas clearly and concisely.",
            "Self-driven professional with a strong work ethic, consistently achieving and exceeding goals with minimal supervision.",
            "Flexible and capable of embracing new challenges and learning opportunities.",
            "Effective stress manager known for maintaining focus and productivity in challenging  environments.",
            "very sharp memory",
            "Good vibes",
            "good sense of humor",
          ]}
        />
      </div>
    </div>
  );
};

export default About;
